export default __webpack_public_path__ + "static/media/ICON.4fd418b1.png";